// @ts-nocheck










import {
  downloadRequestWithToken,
  fetchRequest,
  initialFetchListParams } from
'./index';

import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';


const convertDataFromServer = (monthlyWashingPlan) => ({
  ...monthlyWashingPlan,
  price: convertFromKopToRub(monthlyWashingPlan.price),
  bodyBalance: convertFromKopToRub(monthlyWashingPlan.bodyBalance),
  interiorBalance: convertFromKopToRub(monthlyWashingPlan.interiorBalance),
  engineBalance: convertFromKopToRub(monthlyWashingPlan.engineBalance)
});

const convertDataToServer = ({
  washingPlanVehicles,
  ...monthlyWashingPlan
}) => ({
  ...monthlyWashingPlan,
  price: convertFromRubToKop(monthlyWashingPlan.price),
  bodyBalance: convertFromRubToKop(monthlyWashingPlan.bodyBalance),
  interiorBalance: convertFromRubToKop(monthlyWashingPlan.interiorBalance),
  engineBalance: convertFromRubToKop(monthlyWashingPlan.engineBalance)
});

const convertWashingPlanVehicleFromServer = (
washingPlanVehicle) => (
{
  ...washingPlanVehicle,
  interiorPrice: convertFromKopToRub(washingPlanVehicle.interiorPrice),
  bodyPrice: convertFromKopToRub(washingPlanVehicle.bodyPrice),
  enginePrice: convertFromKopToRub(washingPlanVehicle.enginePrice),
  monthlyWashingPlan: washingPlanVehicle.monthlyWashingPlan ?
  convertDataFromServer(washingPlanVehicle.monthlyWashingPlan) :
  null
});

const convertWashingPlanVehicleToServer = (
washingPlanVehicle) => (
{
  ...washingPlanVehicle,
  interiorPrice: convertFromRubToKop(washingPlanVehicle.interiorPrice),
  bodyPrice: convertFromRubToKop(washingPlanVehicle.bodyPrice),
  enginePrice: convertFromRubToKop(washingPlanVehicle.enginePrice)
});

const convertWashingPlanBalanceFromServer = (
washingPlanBalance) => (
{
  ...washingPlanBalance,
  vehicleInteriorPrice: convertFromKopToRub(
    washingPlanBalance.vehicleInteriorPrice
  ),
  vehicleBodyPrice: convertFromKopToRub(washingPlanBalance.vehicleBodyPrice),
  vehicleEnginePrice: convertFromKopToRub(
    washingPlanBalance.vehicleEnginePrice
  ),
  planSum: convertFromKopToRub(washingPlanBalance.planSum),
  factSum: convertFromKopToRub(washingPlanBalance.factSum),
  vehiclePlanSum: convertFromKopToRub(washingPlanBalance.vehiclePlanSum),
  vehicleFactSum: convertFromKopToRub(washingPlanBalance.vehicleFactSum)
});

export const addMonthlyWashingPlan = async (
monthlyWashingPlan) =>
{
  const added = await fetchRequest.post(
    '/monthlyWashingPlan',
    convertDataToServer(monthlyWashingPlan)
  );
  if (added) return convertDataFromServer(added);
  throw new Error('Не удалось создать план моек');
};

export const updateMonthlyWashingPlan = async (
monthlyWashingPlan) =>
{
  const updated = await fetchRequest.put(
    '/monthlyWashingPlan',
    convertDataToServer(monthlyWashingPlan)
  );
  if (updated) return convertDataFromServer(updated);
  throw new Error('Не удалось обновить план моек');
};

export const fetchMonthlyWashingPlans = async (
params = initialFetchListParams) =>
{
  const washingPlans = await fetchRequest.get('/monthlyWashingPlan', {
    ...initialFetchListParams,
    ...params
  });
  if (washingPlans) {
    return {
      ...washingPlans,
      data: washingPlans.data.map(convertDataFromServer)
    };
  }
  throw new Error('Не удалось получить список планов моек');
};

export const fetchMonthlyWashingPlan = async (
id,
params = {}) =>
{
  const monthlyWashingPlan = await fetchRequest.get(
    `/monthlyWashingPlan/${id}`,
    params
  );
  if (monthlyWashingPlan) return convertDataFromServer(monthlyWashingPlan);
  throw new Error('Не удалось загрузить план моек');
};

export const deleteMonthlyWashingPlan = async (
id) =>
{
  const deleted = await fetchRequest.delete(`/monthlyWashingPlan/${id}`);
  if (deleted) return deleted;
  throw new Error('Не удалось удалить план моек');
};

export const setWashingPlanVehicles = async (
washingVehicles,
washingPlanId) =>
{
  const washingPlanVehicles = await fetchRequest.post(
    `/monthlyWashingPlan/${washingPlanId}/vehicles`,
    washingVehicles.map(convertWashingPlanVehicleToServer)
  );
  if (washingPlanVehicles)
  return washingPlanVehicles.map(convertWashingPlanVehicleFromServer);
  throw new Error('Не удалось указать ТС для плана моек');
};

export const fetchWashingPlanVehicles = async (
washingPlanId) =>
{
  const washingPlanVehicles = await fetchRequest.get(
    `/monthlyWashingPlan/${washingPlanId}/vehicles`
  );
  if (washingPlanVehicles)
  return washingPlanVehicles.map(convertWashingPlanVehicleFromServer);
  throw new Error('Не удалось загрузить ТС для плана моек');
};

export const fetchAllWashingPlanVehicles = async (
params = initialFetchListParams) =>
{
  const washingPlanVehicles = await fetchRequest.get('/washingPlanVehicle', {
    ...initialFetchListParams,
    ...params
  });
  if (washingPlanVehicles) {
    return {
      ...washingPlanVehicles,
      data: washingPlanVehicles.data.map(convertWashingPlanVehicleFromServer)
    };
  }
  throw new Error('Не удалось получить список ТС плана моек');
};

export const fetchWashingPlanBalance = async (
vehicleId,
date) =>
{
  const washingPlanVehicle = await fetchRequest.get(
    `/washingPlanVehicle/plan?vehicleId=${vehicleId}&date=${date}`
  );
  if (washingPlanVehicle)
  return convertWashingPlanBalanceFromServer(washingPlanVehicle);
  return null;
  //throw new Error('Не удалось загрузить план моек для текущего ТС');
};

export const print = async (monthlyWashingPlanId) => {
  const printed = await downloadRequestWithToken(
    `/washingPlanVehicle/${monthlyWashingPlanId}/print`
  );
  if (printed) return printed;
  throw new Error('Не удалось загрузить файл');
};

export const printVehiclesWashings = async (
monthlyWashingPlanId,
filters) =>
{
  const printed = await downloadRequestWithToken(
    `/washingPlanVehicle/${monthlyWashingPlanId}/printReport`,
    {
      ...filters,
      washingPlanId: monthlyWashingPlanId
    }
  );
  if (printed) return printed;
  throw new Error('Не удалось загрузить файл');
};

export default {
  addMonthlyWashingPlan,
  updateMonthlyWashingPlan,
  fetchMonthlyWashingPlans,
  deleteMonthlyWashingPlan,
  fetchMonthlyWashingPlan,
  setWashingPlanVehicles,
  fetchWashingPlanVehicles,
  fetchAllWashingPlanVehicles,
  fetchWashingPlanBalance,
  print,
  printVehiclesWashings
};
